import type { LocalDateProvider } from '../../application/ports/LocalDateProvider';

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

export class SystemLocalDateProvider implements LocalDateProvider {
  public constructor(private readonly now: () => Date = () => new Date()) {}

  public today(): string {
    const date = this.now();
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  }
}
